@if (dashboardContent.hasValue()) {
  <div class="header">
    <p class="left sd-headline sd-headline--size-xl">{{ dashboardContent.value()?.name }}</p>
    <div class="center">
      <wct-filter
        [type]="FilterType.RADIO_BUTTON"
        [filter]="viewSwitch()"
        (selected)="changeView($event)"></wct-filter>
    </div>
    <div class="right">
      <wct-filter
        [type]="FilterType.DATE_PICKER"
        [range]="dateRange()"
        [filter]="dateFilter()"
        (selected)="changeDate($event)"></wct-filter>
      @if (valueDisplayFilter(); as valueDisplayFilter) {
        <wct-filter
          [type]="FilterType.DROPDOWN"
          [multiValue]="false"
          [filter]="valueDisplayFilter"
          (selected)="changeValueDisplay($event)"></wct-filter>
      }
      <sd-6-17-1-button
        class="filter-button"
        variant="secondary"
        (click)="openFilterPanel()">
        <sd-6-17-1-icon
          library="{{ iconLibrary }}"
          name="system/filter-empty"
          slot="icon-left"></sd-6-17-1-icon>
        <span class="filter-button-label">
          Filter
          @if (activeFilterCount() > 0) {
            ({{ activeFilterCount() }})
          }
        </span>
      </sd-6-17-1-button>
      <sd-6-17-1-dropdown
        #moreMenu
        distance="4"
        rounded>
        <sd-6-17-1-button
          variant="tertiary"
          slot="trigger">
          <sd-6-17-1-icon
            library="{{ iconLibrary }}"
            name="system/more-functions"></sd-6-17-1-icon>
        </sd-6-17-1-button>
        <sd-6-17-1-menu>
          @if (isSecuritiesTab()) {
            <sd-6-17-1-menu-item>
              <sd-6-17-1-icon
                library="{{ iconLibrary }}"
                name="system/duplicate"
                slot="icon-indent"></sd-6-17-1-icon>
              {{ 'dashboard.copyMenu' | transloco }}
              <sd-6-17-1-menu
                class="export-submenu copy-submenu"
                slot="submenu">
                @for (curFormat of copyFormats; track curFormat) {
                  <sd-6-17-1-menu-item
                    sdCloseOnSelect
                    (click)="onCopyClick(curFormat)">
                    {{ curFormat }}
                  </sd-6-17-1-menu-item>
                }
              </sd-6-17-1-menu>
            </sd-6-17-1-menu-item>
          }
          <sd-6-17-1-menu-item>
            <sd-6-17-1-icon
              library="{{ iconLibrary }}"
              name="system/download"
              slot="icon-indent"></sd-6-17-1-icon>
            {{ 'dashboard.exportMenu' | transloco }}
            <sd-6-17-1-menu
              class="export-submenu"
              slot="submenu">
              @if (isSecuritiesTab()) {
                @for (curFormat of exportFormats; track curFormat) {
                  <sd-6-17-1-menu-item
                    sdCloseOnSelect
                    (click)="onExportClick(curFormat)">
                    {{ curFormat }}
                  </sd-6-17-1-menu-item>
                }
                <sd-6-17-1-menu-item
                  sdCloseOnSelect
                  (click)="onImageExportClick(pdfFormat)">
                  {{ pdfFormat }}
                </sd-6-17-1-menu-item>
              } @else {
                @for (curFormat of imageExportFormats; track curFormat) {
                  <sd-6-17-1-menu-item
                    sdCloseOnSelect
                    (click)="onImageExportClick(curFormat)">
                    {{ curFormat }}
                  </sd-6-17-1-menu-item>
                }
              }
            </sd-6-17-1-menu>
          </sd-6-17-1-menu-item>
          <sd-6-17-1-menu-item>
            <sd-6-17-1-icon
              library="{{ iconLibrary }}"
              name="system/share"
              slot="icon-indent"></sd-6-17-1-icon>
            Ansicht teilen
          </sd-6-17-1-menu-item>
          <sd-6-17-1-menu-item>
            <sd-6-17-1-icon
              library="{{ iconLibrary }}"
              name="system/pen"
              slot="icon-indent"></sd-6-17-1-icon>
            Dashboard umbenennen
          </sd-6-17-1-menu-item>
          <sd-6-17-1-menu-item>
            <sd-6-17-1-icon
              library="{{ iconLibrary }}"
              name="system/trash"
              slot="icon-indent"></sd-6-17-1-icon>
            Dashboard löschen
          </sd-6-17-1-menu-item>
          <sd-6-17-1-menu-item
            sdCloseOnSelect
            (click)="openSaveTemplateDialog()">
            <sd-6-17-1-icon
              library="{{ iconLibrary }}"
              name="system/star-empty"
              slot="icon-indent"></sd-6-17-1-icon>
            Neue Vorlage speichern
          </sd-6-17-1-menu-item>
          <sd-6-17-1-menu-item
            sdCloseOnSelect
            (click)="openFilterPanel()">
            <sd-6-17-1-icon
              library="{{ iconLibrary }}"
              name="system/filter-empty"
              slot="icon-indent"></sd-6-17-1-icon>
            Filter
          </sd-6-17-1-menu-item>
        </sd-6-17-1-menu>
      </sd-6-17-1-dropdown>
    </div>
  </div>

  <div class="toolbar">
    @if (fundsFilter()) {
      <wct-filter
        style="width: 20em"
        [multiValue]="false"
        [filter]="fundsFilter()!"
        (selected)="changeFunds($event)"></wct-filter>
    }
  </div>

  <div
    class="export-area"
    #exportArea
    [class.capturing]="capturing()">
    <div class="export-header">
      <div class="export-brand">
        @if (exportLogo(); as logo) {
          <img
            class="export-logo"
            alt="Union Investment"
            [src]="logo" />
        } @else {
          <span class="export-brand-mark">U</span>
          <span class="export-brand-name">
            Union
            <br />
            Investment
          </span>
        }
      </div>
      <div class="export-title">
        <strong>{{ dashboardContent.value()?.name }}</strong>
        <span>{{ selectedFund() }}</span>
        <span>{{ exportValueMode() }}</span>
      </div>
    </div>
    <app-container>
      @if (tabContent.value()) {
        @for (curTile of tabContent.value()!.tiles; track $index) {
          <app-tile
            [id]="curTile.id"
            [col]="curTile.columns!"
            [row]="curTile.rows!"
            [filter]="tileFilter()"></app-tile>
        }
      } @else if (tabContent.isLoading()) {
        <sd-6-17-1-loader color="primary"></sd-6-17-1-loader>
      } @else if (tabContent.error()) {
        <span class="error">Fehler beim Laden der Tabs</span>
      }
    </app-container>
    <p class="export-footer">Stichtag: {{ exportDateLabel() }}</p>
  </div>

  @if (capturing()) {
    <div class="capture-overlay">
      <sd-6-17-1-loader color="primary"></sd-6-17-1-loader>
    </div>
  }

  <app-filter-sidepanel
    #filterSidepanel
    [dashboardId]="id()"
    [activeTabName]="activeTabName()"
    [filter]="filterValues()"
    (selectionChange)="onFilterSelectionChange($event)"></app-filter-sidepanel>

  <app-export-dialog
    #appExportDialog
    (exported)="onExportConfirmed($event)"></app-export-dialog>
  <app-image-export-dialog
    #appImageExportDialog
    (downloaded)="onImageDownload($event)"
    (copied)="onImageCopy()"></app-image-export-dialog>
} @else if (dashboardContent.isLoading()) {
  <div class="full">
    <sd-6-17-1-loader color="primary"></sd-6-17-1-loader>
  </div>
} @else if (dashboardContent.error()) {
  <div class="full">Fehler</div>
}
